import { createSignal, Show } from "solid-js";
import { View, Text, hexColor } from "@lightningtv/solid";
import { fontFamily } from "../../translations/configuration";

const FormatOption = (props: {
  ref?: (el: any) => void;
  y: number;
  label: string;
  selected: boolean;
  onEnter?: () => void;
  onUp?: () => void;
  onDown?: () => void;
  onRight?: () => void;
}) => {
  const [focused, setFocused] = createSignal(false);
  return (
    <View
      ref={props.ref}
      x={0} y={props.y}
      width={490} height={68}
      borderRadius={12}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onEnter={props.onEnter}
      onUp={props.onUp}
      onDown={props.onDown}
      onRight={props.onRight}
    >
      {/* Blue border — visible because outer wrapper has no color */}
      <Show when={focused()}>
        <View x={-2} y={-2} width={494} height={72} borderRadius={14} color={hexColor("#2563eb")} zIndex={-1} />
      </Show>

      {/* Content background */}
      <View x={0} y={0} width={490} height={68} borderRadius={12} color={hexColor(props.selected ? "#111c33" : "#0d1117")}>
        <View x={20} y={24} width={20} height={20} borderRadius={10} color={hexColor(props.selected ? "#2563eb" : "#374151")}>
          <Show when={props.selected}>
            <View x={5} y={5} width={10} height={10} borderRadius={5} color={hexColor("#ffffff")} />
          </Show>
        </View>
        <Text x={54} y={20} style={{
          fontSize: 22,
          color: hexColor(props.selected ? "#f0f6fc" : "#8b949e"),
          fontWeight: props.selected ? "bold" : "normal",
          fontFamily: fontFamily(),
        }}>
          {props.label}
        </Text>
      </View>
    </View>
  );
};

export default FormatOption;
